module.exports = __webpack_public_path__ + "img/partner-belt.6922926f.png";